var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKsmClogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.669,
    height: 82.333,
    viewBox: "0 0 122.669 82.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MAIN-LOGO_copy-01",
    "data-name": "MAIN-LOGO copy-01",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3214",
    "data-name": "Group 3214",
    transform: "translate(30.36 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M229.32.09a37.65,37.65,0,0,1,9.794,2.794A36.272,36.272,0,0,1,248.927.146Z",
    transform: "translate(-208.625 -0.071)",
    fill: "#8eb4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M174.027,2.82a37.733,37.733,0,0,0-9.794-2.8q-1.112-.007-2.224-.011a4.969,4.969,0,0,0-1.211.08,5.021,5.021,0,0,0-1.209.394,5.237,5.237,0,0,0-.913.554,6.2,6.2,0,0,0-.9.862c-.565.679-5.532,9.037-12.189,20.531A103.352,103.352,0,0,1,174.027,2.82Z",
    transform: "translate(-143.537 -0.005)",
    fill: "#347381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M229.32,229.754a37.651,37.651,0,0,0,9.794-2.794,36.272,36.272,0,0,0,9.814,2.738Z",
    transform: "translate(-208.625 -176.432)",
    fill: "#8eb4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M174.027,158.464a37.733,37.733,0,0,1-9.794,2.8q-1.112.007-2.224.011a4.97,4.97,0,0,1-1.211-.08,5.022,5.022,0,0,1-1.209-.394,5.238,5.238,0,0,1-.913-.554,6.2,6.2,0,0,1-.9-.862c-.565-.679-5.532-9.037-12.189-20.531a103.353,103.353,0,0,0,28.437,19.614Z",
    transform: "translate(-143.537 -107.938)",
    fill: "#dfb254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M146.045,70.57c-1.307,1.037-2.654,2.162-4.027,3.384-1.267,1.127-2.449,2.242-3.553,3.331a14.154,14.154,0,0,0-1.053,1.336,4.669,4.669,0,0,0-.973,1.9,5.5,5.5,0,0,0-.071.864,6.128,6.128,0,0,0,.071,1.033,11.33,11.33,0,0,0,.568,1.376c1.075,2.182,2.542,3.368,4.673,5.138,1.02.846,2.707,2.258,5.025,4.234a88.613,88.613,0,0,1-.659-22.6Z",
    transform: "translate(-136.367 -54.86)",
    fill: "#8eb4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M273.3,2.82a37.733,37.733,0,0,1,9.794-2.8q1.112-.007,2.224-.011a4.969,4.969,0,0,1,1.211.08,5.021,5.021,0,0,1,1.209.394,5.236,5.236,0,0,1,.913.554,6.2,6.2,0,0,1,.9.862c.565.679,5.532,9.037,12.189,20.531A103.44,103.44,0,0,0,273.3,2.82Z",
    transform: "translate(-242.814 -0.005)",
    fill: "#347381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M273.3,158.464a37.733,37.733,0,0,0,9.794,2.8q1.112.007,2.224.011a4.97,4.97,0,0,0,1.211-.08,5.021,5.021,0,0,0,1.209-.394,5.236,5.236,0,0,0,.913-.554,6.2,6.2,0,0,0,.9-.862c.565-.679,5.532-9.037,12.189-20.531A103.353,103.353,0,0,1,273.3,158.464Z",
    transform: "translate(-242.814 -107.938)",
    fill: "#347281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M364.479,70.57c1.307,1.037,2.654,2.162,4.027,3.384,1.267,1.127,2.449,2.242,3.553,3.331a14.153,14.153,0,0,1,1.053,1.336,4.67,4.67,0,0,1,.973,1.9,5.5,5.5,0,0,1,.071.864,6.132,6.132,0,0,1-.071,1.033,11.333,11.333,0,0,1-.568,1.376c-1.075,2.182-2.542,3.368-4.673,5.138-1.02.846-2.707,2.258-5.025,4.234a88.613,88.613,0,0,0,.659-22.6Z",
    transform: "translate(-313.181 -54.86)",
    fill: "#8eb4bb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3213",
    "data-name": "Group 3213",
    transform: "translate(22.745 9.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_509_",
    transform: "translate(0.163 10.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_514_",
    d: "M241.941,167.864l-.993-.842a.326.326,0,0,0-.314-.238.328.328,0,1,0,0,.657.323.323,0,0,0,.1-.018.88.88,0,0,1,.258.488c0,1.082-1.737,1.017-1.737,1.017.808,1.389,2.358.031,2.358.031a2.3,2.3,0,0,0,1.394.6.327.327,0,1,0,.1-.514l-.5-.557s-.223-.537,4.673-2.988c4.435-2.222,7.329-1.592,7.329-1.592C250.893,160.475,241.941,167.864,241.941,167.864Z",
    transform: "translate(-239.26 -147.102)",
    fill: "#706f6e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_513_",
    d: "M251.945,167.864l.993-.842a.328.328,0,1,1,.314.419.309.309,0,0,1-.1-.018.879.879,0,0,0-.258.488c0,1.082,1.737,1.017,1.737,1.017-.806,1.389-2.355.031-2.355.031a2.309,2.309,0,0,1-1.394.6.322.322,0,0,1-.245.111.328.328,0,1,1,.14-.626l.5-.557s.223-.537-4.673-2.988c-4.435-2.222-7.329-1.592-7.329-1.592C242.992,160.475,251.945,167.864,251.945,167.864Z",
    transform: "translate(-239.268 -147.102)",
    fill: "#706f6e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_510_",
    transform: "translate(2.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_512_",
    d: "M269.5,124.166h-.169l.2,2.142h-.169l.269,2.476-.888.788h2.117l-.891-.788.272-2.476h-.171l.2-2.142h-.169l.236-2.077h-.272l.136-2.209-.4.1-.4-.1.12,2.209h-.269Z",
    transform: "translate(-265.107 -113.582)",
    fill: "#706f6e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_511_",
    d: "M261.7,96.645a3.967,3.967,0,0,0-2.482-2.805.958.958,0,0,1,.85.111l.2.178-.022-.245s.381-.022.492.178l-.022-.2a2.9,2.9,0,0,1,.514.4s.134-.245.269-.178-.069-.334-.245-.51a4.407,4.407,0,0,0-1.521-.712.46.46,0,0,1,.358-.178,1.235,1.235,0,0,0-.8-.245s-.022-.134.156-.178.022-.223-.069-.223.247-.2.247-.2-.559-.735-1.968.332l-.111.067s-.045-.356-.225-.445-.089.089-.089.089l-.151-.134v-.069l-.038.036-.036-.031v.062l-.151.134s.089-.178-.089-.087-.223.445-.223.445l-.111-.067c-1.411-1.066-1.968-.332-1.968-.332s.336.2.245.2-.245.178-.067.223.158.178.158.178a1.225,1.225,0,0,0-.8.247.448.448,0,0,1,.356.176,4.43,4.43,0,0,0-1.518.715c-.178.178-.378.579-.245.512s.269.178.269.178a2.77,2.77,0,0,1,.514-.4l-.022.2c.111-.2.492-.178.492-.178l-.022.245.2-.178a.954.954,0,0,1,.848-.111A3.962,3.962,0,0,0,252.4,96.65c-.045.223.134.223.223.378s.292-.178.292-.178l-.022.512a5.717,5.717,0,0,1,.356-1.2s0,.4.089.134.223-.67.223-.67,0,.356.045.111a1.865,1.865,0,0,1,.289-.579s.047.312.069.2a2.186,2.186,0,0,1,.312-.445.505.505,0,0,0,.292-.111,1.089,1.089,0,0,1,.423-.156,8.907,8.907,0,0,0-1.093,1.583,9.281,9.281,0,0,0-.22,2.583c.2-.022.358-.423.358-.423l.156.178a2.306,2.306,0,0,0,.111-.953l0,0s0,0,0,0c0,.069.2.216.289-.027a3.571,3.571,0,0,0,.131-.623s.158.579.158.134a1.982,1.982,0,0,1,.2-.824l.156-.378s.111-.4.2-.312a.769.769,0,0,1,.134.178s.245-.134.156,0a.38.38,0,0,0-.045.289s.178.067.111.178-.492.712-.492.712l.292-.022c-.381.267-.49,1.024-.4.98s.158.089.111.156-.109.512-.067.4.4-.334.4-.334l.047.913.289-.134.158.468s.02-.735.109-.715.114.136.114.136l.089.332.111-.087.452.094v.02l.051-.009.033.007v-.013l.452-.094.111.089.089-.334s.022-.114.111-.134.111.712.111.712l.156-.468.292.134.045-.913s.358.223.4.334-.022-.334-.067-.4.022-.2.111-.156-.022-.712-.4-.98l.289.022s-.425-.6-.492-.712.111-.178.111-.178a.38.38,0,0,0-.045-.289c-.089-.134.156,0,.156,0a.769.769,0,0,1,.134-.178c.089-.091.2.312.2.312l.158.378a1.969,1.969,0,0,1,.2.824c0,.445.156-.134.156-.134a3.448,3.448,0,0,0,.134.623c.089.24.285.094.289.024v0a2.351,2.351,0,0,0,.111.955l.156-.178s.156.4.358.423a9.289,9.289,0,0,0-.223-2.58,8.914,8.914,0,0,0-1.1-1.581,1.1,1.1,0,0,1,.425.156.5.5,0,0,0,.289.111,2.118,2.118,0,0,1,.314.445c.022.111.069-.2.069-.2a1.836,1.836,0,0,1,.289.579c.044.245.044-.114.044-.114l.223.668c.089.267.089-.134.089-.134a5.721,5.721,0,0,1,.358,1.2l-.022-.512s.2.332.292.176S261.746,96.868,261.7,96.645Z",
    transform: "translate(-252.388 -91.592)",
    fill: "#706f6e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_502_",
    d: "M249.624,45.9l.334-.525a.872.872,0,0,0-.9.777l-.35,2.93h-.332V46.219A1.963,1.963,0,0,0,246.3,44.1c-1.964,0-1.928,2.235-1.928,2.235V47.84h.83V46.649c0-.6.118-1.507,1.2-1.507,1.1,0,1.064,1.541,1.064,1.541v2.3h-3.384l0,0H244c-.016-.154-.029-.508-.029-1.256,0-1.9-1.429-1.837-2.928-1.705a6.4,6.4,0,0,1-2.511-.232s1.779,4.519,2.529,5.263,1.347,1.258,5.205,1.258,4.84-.548,5-.844,2.845-5.448,2.845-5.448C253.05,46.9,249.624,45.9,249.624,45.9Zm-8.585.318a.311.311,0,1,1-.312.309A.311.311,0,0,1,241.039,46.219Zm-.761,0a.311.311,0,1,1-.312.309A.309.309,0,0,1,240.278,46.219Zm1.131,3.558-1.38-2.8c.948.63,1.465-.579,2.5-.381s.815,2.5.815,2.5A2.573,2.573,0,0,0,241.409,49.777Zm4.869,2.269c-2.445,0-4.426-.374-4.426-.833s1.984-.833,4.426-.833,4.43.374,4.43.833S248.722,52.046,246.278,52.046Zm3.166-2.945s-.216-2.3.815-2.5,1.547,1.011,2.493.381l-1.38,2.8A2.565,2.565,0,0,0,249.443,49.1Z",
    transform: "translate(-238.53 -44.1)",
    fill: "#706f6e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_",
    transform: "translate(0 62.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    d: "M5.7,287.885H.08V283.6a1.859,1.859,0,0,1,.091-.552,1.2,1.2,0,0,1,.316-.494,1.392,1.392,0,0,1,1.04-.448H4.648v4.513H5.7v1.269Zm-3.486-6.316H.465V280.28H2.213Zm.857,5.065v-3.262H2.453a.706.706,0,0,0-.8.8v2.465Zm1.587-5.065H2.916V280.28H4.657Z",
    transform: "translate(-0.062 -280.262)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_495_",
    d: "M26.444,310.017h-2.2V308.75h2.2Z",
    transform: "translate(-18.843 -302.394)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_491_",
    d: "M38.272,292.993v1.267H33.1v-1.267h2.8V288.48h1.572v4.513Zm-1.937,3.339h-1.75v-1.287h1.75Zm2.445,0H37.038v-1.287h1.741Z",
    transform: "translate(-25.731 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_488_",
    d: "M60.314,292.993v1.267H55.22v-1.267h2.8V288.48h1.572v4.513Zm-.65,3.339h-1.75v-1.287h1.75Z",
    transform: "translate(-42.926 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_485_",
    d: "M85.352,287.846H77.03V286.58h1.046v-6.35h1.581v2.91q.371-1.072,1.9-1.073h2.959v4.513h.833Zm-2.413-1.267v-3.09H81.814q-2.157,0-2.157,1.783v1.307Z",
    transform: "translate(-59.881 -280.223)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_483_",
    d: "M113.3,286.6h1.587V280.26h1.572v7.61H113.3Z",
    transform: "translate(-88.076 -280.247)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_481_",
    d: "M134.31,287.87v-7.61h1.572v7.61Z",
    transform: "translate(-104.408 -280.247)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_479_",
    d: "M158.871,294.213H155.14v-1.267h2.151v-3.006q0-.374-.294-.448h-1.356V288.42h2.05c.788,0,1.18.354,1.18,1.06v4.733Z",
    transform: "translate(-120.601 -286.59)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_476_",
    d: "M182.007,294.26h-3.242v-4.239q0-1.54,1.71-1.541h3.1v4.513h.871v1.267h-.871v.505c0,1.037-.761,1.558-1.781,1.558H178.75v-1.184h2.436s.822.076.822-.347Zm-.013-1.267v-3.248h-.777q-.872,0-.871.8v2.451Z",
    transform: "translate(-138.954 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_474_",
    d: "M205.324,310.017h-2.2V308.75h2.2Z",
    transform: "translate(-157.899 -302.394)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_472_",
    d: "M211.98,294.26v-1.267h2l-.6-.888V288.48h3.291q1.373,0,1.371,1.436v1.57h-1.581v-.944q0-.8-.724-.8h-.786v2.284l.739.964h3.322v1.267Z",
    transform: "translate(-164.786 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_470_",
    d: "M242.51,292.993h1.7V288.48h1.565v4.513h1.5V288.48h1.565v4.513h1.356V288.48h1.572v5.78h-9.248v-1.267Z",
    transform: "translate(-188.519 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    d: "M304.9,287.823H297.82v-4.232a1.556,1.556,0,0,1,.49-1.069A1.474,1.474,0,0,1,299.4,282v4.555h3.184V280.2h1.572v6.356h.748Zm-4.856-3.847V283.6h.332v-1.122h1.049q.407,0,.407.427v.378h-.479v-.3a.1.1,0,0,0-.051-.1.534.534,0,0,0-.211-.027c-.067,0-.149,0-.245.007v.744h.986v.372h-1.788Z",
    transform: "translate(-231.515 -280.2)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_465_",
    d: "M330.724,310.017h-2.2V308.75h2.2Z",
    transform: "translate(-255.38 -302.394)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_463_",
    d: "M341.234,287.87H337.38V286.6h1.587V280.26h1.572V286.6h.695Z",
    transform: "translate(-262.268 -280.247)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_460_",
    d: "M359.984,294.26H353.59v-1.267h1.031V288.48h3.493q1.172,0,1.171,1.12v3.07c0,.216.1.323.294.323h.407v1.267Zm-2.042-1.267a.536.536,0,0,1-.247-.434.564.564,0,0,1,.009-.1v-2.242c0-.341-.2-.51-.61-.51h-.9v2.669a.554.554,0,0,0,.432.619Z",
    transform: "translate(-274.869 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    d: "M381.28,286.6h1.587V280.26h1.572v7.61H381.28Z",
    transform: "translate(-296.394 -280.247)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_456_",
    d: "M402.28,287.87v-7.61h1.572v7.61Z",
    transform: "translate(-312.719 -280.247)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_451_",
    d: "M428.767,287.885H423.15V283.6a1.8,1.8,0,0,1,.094-.552,1.2,1.2,0,0,1,.316-.494,1.393,1.393,0,0,1,1.042-.448h3.119v4.513h1.049v1.269Zm-3.491-6.316h-1.748V280.28h1.748Zm.866,5.065v-3.262h-.617a.706.706,0,0,0-.8.8v2.465Zm1.576-5.065h-1.741V280.28h1.741Z",
    transform: "translate(-328.943 -280.262)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    d: "M449.514,310.017h-2.2V308.75h2.2Z",
    transform: "translate(-347.724 -302.394)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    d: "M461.274,286.618v1.267H456.18v-1.267h2.8v-4.513h1.572v4.513Zm-.646-5.049h-1.741V280.28h1.741Z",
    transform: "translate(-354.619 -280.262)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    d: "M477.94,294.26v-1.267h2.8V288.48h1.572v5.78Zm1.928,2.073h-1.75v-1.287h1.75Zm2.442,0h-1.741v-1.287h1.741Z",
    transform: "translate(-371.535 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_440_",
    d: "M508.956,294.213H504.41v-1.267h2.148v-3.006c0-.249-.1-.4-.292-.448h-1.356V288.42h2.05q1.179,0,1.18,1.06v3.469h.817v1.265Z",
    transform: "translate(-392.111 -286.59)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_437_",
    d: "M523.752,292.993h1.109V288.48h3.491q1.172,0,1.171,1.12v3.07c0,.216.1.323.292.323v1.267H523.75v-1.267Zm4.43,0a.536.536,0,0,1-.247-.434c0-.031,0-.067.007-.1v-2.242c0-.341-.2-.51-.608-.51h-.9v2.669a.552.552,0,0,0,.432.619Z",
    transform: "translate(-407.146 -286.637)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_",
    transform: "translate(0 13.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_428_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_435_",
    d: "M0,339.14H1.472v2.353l2.075-2.353H5.292l-2.669,3.046,2.93,3.78H3.827l-2.355-3.032v3.032H0Z",
    transform: "translate(0 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    d: "M29.53,339.14h1.445v6.826H29.53Z",
    transform: "translate(-22.956 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_431_",
    d: "M41.81,339.14h1.4l3.27,4.493V339.14h1.456v6.826h-1.4l-3.266-4.477v4.477H41.812V339.14Z",
    transform: "translate(-32.502 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_429_",
    d: "M80.443,340.342l-.977.864a3.047,3.047,0,0,0-2.162-.875,2.638,2.638,0,0,0-1.8.637,1.984,1.984,0,0,0-.726,1.547,2.041,2.041,0,0,0,.753,1.6,2.729,2.729,0,0,0,1.859.655A2.494,2.494,0,0,0,78.6,344.5a1.977,1.977,0,0,0,.795-.844H77.284v-1.162h3.665l.011.274a2.916,2.916,0,0,1-.5,1.619,3.282,3.282,0,0,1-1.282,1.169,4.019,4.019,0,0,1-1.846.4,4.493,4.493,0,0,1-2.024-.441,3.411,3.411,0,0,1-1.4-1.256,3.2,3.2,0,0,1-.517-1.754,3.073,3.073,0,0,1,.955-2.246,3.986,3.986,0,0,1,2.95-1.138,4.974,4.974,0,0,1,1.779.314A4.094,4.094,0,0,1,80.443,340.342Z",
    transform: "translate(-57.051 -339.12)",
    fill: "#706f6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_417_",
    transform: "translate(26.952 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_426_",
    d: "M125.5,340.184l-1.024.806a1.472,1.472,0,0,0-1.1-.67.743.743,0,0,0-.445.129.369.369,0,0,0-.171.294.484.484,0,0,0,.122.31,8.928,8.928,0,0,0,1.013.833c.525.394.846.641.957.744a2.585,2.585,0,0,1,.594.726,1.7,1.7,0,0,1-.441,2.073,2.415,2.415,0,0,1-1.61.519,2.61,2.61,0,0,1-1.351-.341,2.8,2.8,0,0,1-.986-1.064l1.162-.628a1.461,1.461,0,0,0,1.2.859.951.951,0,0,0,.6-.185.531.531,0,0,0,.24-.427.689.689,0,0,0-.183-.441,4.95,4.95,0,0,0-.806-.675,7.8,7.8,0,0,1-1.532-1.331,1.57,1.57,0,0,1-.345-.935,1.456,1.456,0,0,1,.577-1.155,2.133,2.133,0,0,1,1.42-.483,2.435,2.435,0,0,1,1.035.225A3.649,3.649,0,0,1,125.5,340.184Z",
    transform: "translate(-121.06 -339.14)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_423_",
    d: "M146.948,339.14h1.474l2.941,6.826h-1.512l-.6-1.407h-3.119l-.623,1.407H144Zm.746,1.81-1.024,2.344h2.046Z",
    transform: "translate(-138.893 -339.14)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    d: "M179.01,339.14h1.423v4.3a1.993,1.993,0,0,0,.109.786.836.836,0,0,0,.361.37,1.242,1.242,0,0,0,.606.138,1.283,1.283,0,0,0,.646-.154.855.855,0,0,0,.376-.39,2.611,2.611,0,0,0,.1-.906v-4.143h1.423v3.965a5.275,5.275,0,0,1-.125,1.394,1.939,1.939,0,0,1-.485.75,2.265,2.265,0,0,1-.822.537,3.094,3.094,0,0,1-1.084.174,2.879,2.879,0,0,1-1.409-.332,2.026,2.026,0,0,1-.857-.833,3.972,3.972,0,0,1-.258-1.688v-3.97Z",
    transform: "translate(-166.108 -339.14)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    d: "M207.48,339.14h1.725a6.255,6.255,0,0,1,2.476.37,3.081,3.081,0,0,1,1.334,1.2,3.79,3.79,0,0,1,.232,3.388,3.013,3.013,0,0,1-.81,1.1,2.968,2.968,0,0,1-1.118.6,8.785,8.785,0,0,1-2.088.167h-1.75V339.14Zm1.445,1.251V344.7h.675a3.754,3.754,0,0,0,1.447-.2,1.674,1.674,0,0,0,.735-.688,2.293,2.293,0,0,0,.285-1.189,2.133,2.133,0,0,0-.681-1.688,2.95,2.95,0,0,0-1.968-.539Z",
    transform: "translate(-188.24 -339.14)",
    fill: "#706f6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_171_",
    transform: "translate(55.104 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_415_",
    d: "M248.835,339.14h1.418l1.77,4.76,1.79-4.76h1.416l1.282,6.826H255.1l-.819-4.312-1.623,4.312h-1.282l-1.61-4.312-.842,4.312H247.51Z",
    transform: "translate(-247.51 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    d: "M291.87,339.14h4.174v1.271h-2.729v1.233h2.729v1.249h-2.729v1.8h2.729v1.276H291.87Z",
    transform: "translate(-281.994 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_410_",
    d: "M315.74,339.14h1.723a6.275,6.275,0,0,1,2.478.37,3.081,3.081,0,0,1,1.334,1.2,3.79,3.79,0,0,1,.232,3.388,3.02,3.02,0,0,1-1.928,1.7,8.785,8.785,0,0,1-2.088.167h-1.75Zm1.443,1.251V344.7h.675a3.747,3.747,0,0,0,1.447-.2,1.662,1.662,0,0,0,.735-.688,2.315,2.315,0,0,0,.285-1.189,2.133,2.133,0,0,0-.681-1.688,2.956,2.956,0,0,0-1.97-.539Z",
    transform: "translate(-300.55 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_313_",
    d: "M346.93,339.14h1.445v6.826H346.93Z",
    transform: "translate(-324.796 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_309_",
    d: "M364.261,340.422l-.966.822a3.162,3.162,0,0,0-2.22-.928,2.548,2.548,0,0,0-1.752.632,2.023,2.023,0,0,0-.712,1.567,2.1,2.1,0,0,0,.316,1.151,2.192,2.192,0,0,0,.893.79,2.834,2.834,0,0,0,1.282.287,2.921,2.921,0,0,0,1.1-.2,3.984,3.984,0,0,0,1.1-.73l.937.873a5.2,5.2,0,0,1-1.521.973,4.606,4.606,0,0,1-1.634.272,4.016,4.016,0,0,1-2.77-.96,3.139,3.139,0,0,1-1.08-2.456,3.093,3.093,0,0,1,.492-1.725,3.5,3.5,0,0,1,1.4-1.211,4.352,4.352,0,0,1,1.97-.459,4.58,4.58,0,0,1,1.732.338A4.145,4.145,0,0,1,364.261,340.422Z",
    transform: "translate(-332.803 -339.12)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_303_",
    d: "M392.55,339.14h1.474l2.941,6.826h-1.512l-.6-1.407h-3.119l-.623,1.407H389.6Zm.746,1.81-1.026,2.344h2.046Z",
    transform: "translate(-357.966 -339.136)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    d: "M425.94,339.14h1.454v5.588h2.122v1.238H425.94Z",
    transform: "translate(-386.216 -339.136)",
    fill: "#706f6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_",
    transform: "translate(101.22 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_167_",
    d: "M461.665,340.51l-.964.819a3.147,3.147,0,0,0-2.213-.928,2.524,2.524,0,0,0-1.748.635,2.01,2.01,0,0,0-.71,1.561,2.118,2.118,0,0,0,.314,1.149,2.152,2.152,0,0,0,.891.788,3.052,3.052,0,0,0,2.375.085,3.926,3.926,0,0,0,1.091-.728l.935.87a5.2,5.2,0,0,1-1.518.968,4.573,4.573,0,0,1-1.63.269,4.007,4.007,0,0,1-2.763-.955,3.129,3.129,0,0,1-1.075-2.449,3.069,3.069,0,0,1,.49-1.719,3.488,3.488,0,0,1,1.4-1.209,4.325,4.325,0,0,1,1.966-.456,4.539,4.539,0,0,1,1.725.338A4.183,4.183,0,0,1,461.665,340.51Z",
    transform: "translate(-454.65 -339.194)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_163_",
    d: "M490.69,339.14h1.443v6.826H490.69Z",
    transform: "translate(-482.666 -339.14)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M501.232,339.14h4.226v1.28h-1.394v5.546h-1.476V340.42H501.23v-1.28Z",
    transform: "translate(-490.86 -339.14)",
    fill: "#706f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "M524.16,339.14h1.561l1.425,2.456,1.42-2.456h1.543l-2.237,3.869v2.957h-1.465v-2.957Z",
    transform: "translate(-508.685 -339.14)",
    fill: "#706f6e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsmClogo);
export default __webpack_public_path__ + "static/media/KSMC logo.59b7bf47dfc698ab3c154e8417bf2189.svg";
export { ForwardRef as ReactComponent };